import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilesEditor.html?raw';
import "../EvBookingEditorTypes";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";

import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import "../../../moreCore/UI/Filetransfer/FileUpload/FileUpload";

class FilesEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;
    fileUpload: MdsLax<InstanceType<typeof FileUpload>>;


    _onChangeEmployeeInput(): void {

    }

    _onUploadFile(p1, p2, p3) {
        console.log("params", p1, p2, p3)

        //this.addValue(this.fileUpload);
        //console.log(this.allValues);
    }

    _onClick_AddTask(): void {
        /*var value = this.employeeInput.getValue();
        var taskType = this.taskTypeSelect.getValue();
        if (value != null && taskType != null) {
            this.emit("added", { employee: value, taskType: taskType });
            this.employeeInput.setValue(null)
            this.taskTypeSelect.setValue(null);
        }*/
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        /*this.taskTypeSelect.setRequestParameter("entityClass", "ev_task_descript");
        this.taskTypeSelect.setUrl("MainCatalogsEditor/LoadMainCatalogSelect");
        this.taskTypeSelect._loadListValues();
        */
        this.domNode.addEventListener('click', function (evt) {

            evt.stopPropagation();

        });

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        
    }
}

export default mdsWidget(FilesEditor);